module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAHBAMAAAAsQKpuAAAAIVBMVEUAAABZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGp1pZ+wAAAACnRSTlMAGde+xg7dzDERl7bNUgAAADRJREFUCNdjaJ7AwDC5gcGqlIG1yoBBaElAyCIBBkYtRy9FBgYGoVWLBIAUY1YiAwgIAzkADcEIxdVfZNMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_down_hover.png
// module id = vd1j
// module chunks = 9